export const BRANDING_LOGO_UPDATE_KEY = 'branding-logo-update'
export const BRANDING_LOGO_RESET_KEY = 'branding-logo-reset'

export const BRANDING_ACCOUNT_SCOPE = {
  scope: 'account:update',
  superScope: ['account:admin'],
}
